export default __webpack_public_path__ + "static/feature4-c576836af4615f323f50048e76670066.webp";